import { Component, inject } from '@angular/core';
import { CategoryInfo } from '@reflact/ipkv-types';
import { Api } from '../api';
import { OutroService } from './outro.service';

@Component({
  standalone: true,
  imports: [],
  templateUrl: './outro.component.html',
  styleUrl: './outro.component.scss'
})
export class OutroComponent {

  public outroService = inject(OutroService);
  public api = inject(Api);

  protected get userSubmitOutroText(): string {
    const categoryInfo = this.api.fallaufgabe?.categoryInfo as (CategoryInfo & {
      FallaufgabeOutro?: string;
      vcOutro?: string;
    }) | undefined;

    if (this.api.fallaufgabe?.type === 'vc') {
      return categoryInfo?.vcOutro ?? '';
    }

    return categoryInfo?.FallaufgabeOutro ?? '';
  }

}
